import axios from 'axios';
import {
    GET_CATEGORIES_SUCCESS,
    GET_CATEGORIES_FAIL,
    GET_CATEGORIES_LIST_SUCCESS,
    GET_CATEGORIES_LIST_FAIL,
    GET_CATEGORY_SUCCESS,
    GET_CATEGORY_FAIL,
    GET_MAIN_CATEGORIES_SUCCESS,
    GET_MAIN_CATEGORIES_FAIL
} from './types';


export const get_categories = () => async dispatch => {
    const config = {
        headers: {
            'Accept': 'application/json'
        }
    };

    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/category/categories`, config);
    
        if (res.status === 200) {
            dispatch({
                type: GET_CATEGORIES_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch({
                type: GET_CATEGORIES_FAIL
            });
        }
    } catch(err) {
        dispatch({
            type: GET_CATEGORIES_FAIL
        });
    }
}

export const get_categories_list = () => async dispatch => {
    const config = {
        headers: {
            'Accept': 'application/json',
            Authorization: `JWT ${localStorage.getItem("access")}`,
        }
    };

    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/category/categories/list/`, config);
    
        if (res.status === 200) {
            dispatch({
                type: GET_CATEGORIES_LIST_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch({
                type: GET_CATEGORIES_LIST_FAIL
            });
        }
    } catch(err) {
        dispatch({
            type: GET_CATEGORIES_LIST_FAIL
        });
    }
}

export const get_category = (id) => async dispatch => {
    const config = {
        headers: {
            'Accept': 'application/json',
            Authorization: `JWT ${localStorage.getItem("access")}`,
        }
    };

    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/category/categories/${id}/`, config);
    
        if (res.status === 200) {
            dispatch({
                type: GET_CATEGORY_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch({
                type: GET_CATEGORY_FAIL
            });
        }
    } catch(err) {
        dispatch({
            type: GET_CATEGORY_FAIL
        });
    }
}

export const get_categories_list_page = (p) => async dispatch => {
    const config = {
        headers: {
            'Accept': 'application/json',
            Authorization: `JWT ${localStorage.getItem("access")}`,
        }
    };

    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/category/categories/list/?page=${p}`, config);
    
        if (res.status === 200) {
            dispatch({
                type: GET_CATEGORIES_LIST_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch({
                type: GET_CATEGORIES_LIST_FAIL
            });
        }
    } catch(err) {
        dispatch({
            type: GET_CATEGORIES_LIST_FAIL
        });
    }
}

export const get_main_categories = () => async dispatch => {
    const config = {
        headers: {
            'Accept': 'application/json',
            Authorization: `JWT ${localStorage.getItem("access")}`,
        }
    };

    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/category/main-categories/`, config);
    
        if (res.status === 200) {
            dispatch({
                type: GET_MAIN_CATEGORIES_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch({
                type: GET_MAIN_CATEGORIES_FAIL
            });
        }
    } catch(err) {
        dispatch({
            type: GET_MAIN_CATEGORIES_FAIL
        });
    }
}